<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("supplier_due_payable_list") }}</h4>
        </div>
      </div>

      <div v-if="can('purchase.supplier_due_payment', 'W')" class="page-btn">
        <router-link to="/supplier/due" class="btn btn-added">
          <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("new_due_pay") }}
        </router-link>
      </div>
    </div>

    <ThemeDataTable
      ref="supplierDueTable"
      table-id="SupplierDueTable"
      :fetch-data="fetchPaymentsPage"
      :filters="tableFilters"
      default-order-dir="desc"
    >
      <template #default="{ rows }">
        <thead class="thead-light">
          <tr>
            <th>{{ $t("voucher_no") }}</th>
            <th>{{ $t("voucher_date") }}</th>
            <th class="no-sort">{{ $t("supplier_name") }}</th>
            <th class="no-sort">{{ $t("supplier_phone") }}</th>
            <th class="no-sort">{{ $t("payment_type") }}</th>
            <th>{{ $t("narration") }}</th>
            <th>{{ $t("total_paid_amount") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="payment in rows" :key="payment.id">
            <td>{{ payment.voucher_id }}</td>
            <td>{{ payment.voucher_date }}</td>
            <td>
              <div class="d-flex align-items-center">
                <span class="avatar avatar-md me-2">
                  <span
                    class="avatar-title rounded bg-light text-secondary d-flex align-items-center justify-content-center w-100 h-100"
                  >
                    <i class="ti ti-truck"></i>
                  </span>
                </span>
                <span>{{ payment.supplier_name || '—' }}</span>
              </div>
            </td>
            <td>{{ payment.supplier_phone || '—' }}</td>
            <td>{{ payment.payment_method || '—' }}</td>
            <td>{{ payment.narration || '—' }}</td>
            <td>{{ formatMoney(payment.paid_amount) }}</td>
          </tr>
        </tbody>
      </template>
    </ThemeDataTable>
  </div>
</template>

<script>
import { can as canAccess } from "@/helpers/permission";
import apiUrls from '@/urls';
import ThemeDataTable from '@/components/common/ThemeDataTable.vue';
import { truncateMoney2 } from '@/utils';

export default {
  components: {
    ThemeDataTable,
  },
  data() {
    return {
      filterOptions: {
        payment_method: [],
      },
    };
  },
  computed: {
    tableFilters() {
      return [
        {
          key: 'payment_method',
          label: this.$t('payment_type'),
          options: this.filterOptions.payment_method,
        },
      ];
    },
  },
  methods: {
    formatMoney(amount) {
      return truncateMoney2(amount);
    },

    async fetchFilterOptions() {
      try {
        const response = await this.$axios.get(apiUrls.supplier_payment.get, {
          params: { filter_options: 1 },
        });
        this.filterOptions.payment_method = response.data?.payment_method || [];
      } catch (error) {
        console.error('Error fetching supplier due filter options:', error);
      }
    },

    async fetchPaymentsPage({ draw, start, length, search, orderColumn, orderDir, filters }) {
      const params = {
        draw,
        start,
        length,
        'search[value]': search || '',
        'order[0][column]': orderColumn,
        'order[0][dir]': orderDir,
        ...filters,
      };

      const response = await this.$axios.get(apiUrls.supplier_payment.get, { params });
      const payload = response.data || {};

      return {
        data: payload.data || [],
        recordsTotal: payload.recordsTotal || 0,
        recordsFiltered: payload.recordsFiltered || 0,
      };
    },

    can(code, requiredLevel) {
      return canAccess(code, requiredLevel);
    },
  },
  created() {
    this.fetchFilterOptions();
  },
};
</script>
